import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from 'general/js/store';
import BaseComponent from 'foundation/base-component';
import QualLeaderboardLayout from './qual-leaderboard-layout';

class QualLeaderboardComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.init();
    }

    static getRequiredRefs() {
        return ['container'];
    }

    init() {
        this.render();
    }

    onDestroy() {
        ReactDOM.unmountComponentAtNode(this.refs.container);
    }

    render() {
        ReactDOM.render(
            <Provider store={store}>
                <QualLeaderboardLayout options={this.options} />
            </Provider>,
            this.refs.container
        );
    }
}

export default QualLeaderboardComponent;
